import { FC } from 'react'
import { Outlet } from 'react-router-dom'

// ROUTES
import { ViewPhoneRoute } from './view'
import { VerifyPhoneRoute } from './verify'

// TYPES
import type { RouteObject } from 'react-router-dom'
import { useProfilePhoneContext } from '..'


const Component: FC<{}> = () => {
    const context = useProfilePhoneContext()
    return <Outlet context={context} />
}

const PhoneIdRoute: RouteObject = {
    path: ":phoneId",
    Component,
    children: [
        ViewPhoneRoute,
        VerifyPhoneRoute,
    ],
}

export { PhoneIdRoute }